// Shared comparator for Page.Table rows. Cell values are objects like { value, label };
// sorting prefers label, then value. Null/undefined values sort to the end. Extracted from
// PageTable so pages that paginate externally (usePagination) can sort the FULL dataset
// before slicing: PageTable's internal sort only applies when no pagination prop is passed.
const getSortValue = (item, key) => {
  const value = item[key];

  if (!value || typeof value !== 'object') {
    return value;
  }

  if ('label' in value && value.label != null) {
    return value.label;
  }

  if ('value' in value) {
    return value.value;
  }

  return value;
};

const sortTableData = (data, sortConfig) => {
  if (!sortConfig) {
    return data;
  }

  return [...data].sort((a, b) => {
    const aValue = getSortValue(a, sortConfig.key);
    const bValue = getSortValue(b, sortConfig.key);

    if (aValue == null && bValue == null) {
      return 0;
    }
    if (aValue == null) {
      return 1;
    }
    if (bValue == null) {
      return -1;
    }

    if (aValue < bValue) {
      return sortConfig.direction === 'ascending' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'ascending' ? 1 : -1;
    }
    return 0;
  });
};

export default sortTableData;
